import { Button, Dialog } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from '../../../components/hooks/useTheme'
import useConfirm from '../../../components/hooks/useConfirm'
import useAuth from '../../../components/hooks/useAuth'
import { branchTimezone } from '../../../utils/summaryCalculation'
import colorConfigs from '../../../configs/colorConfigs'
import EmailValidatedComponent from '../../../components/EmailValidatedComponent'
import Cookies from 'js-cookie'
import { post_DisabledVehicleLocation } from '../../../services/DisabledVehicleLocation'
import PhoneNumberInput from '../../../components/common/PhoneNumberInput'
import useTenant from '../../../components/hooks/useTenant'

type ShareLocationRequestProps = {
    open: boolean;
    onClose: () => void;
    isCompletedOrCancelled: boolean;
    setPleaseWait: (value: boolean) => void;
    reservationId: number;
    summaryData: any;
    customerPhoneNumber: string;
    formattedCreatedAt: string;
    refreshTheShareLocationRequest: () => void;
}

const ShareLocationRequest = ({
    open,
    onClose,
    isCompletedOrCancelled,
    setPleaseWait,
    reservationId,
    summaryData,
    customerPhoneNumber,
    formattedCreatedAt,
    refreshTheShareLocationRequest
}: ShareLocationRequestProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();

    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [email, setEmail] = useState<string>("");

    const UpdateTimezone = branchTimezone(formattedCreatedAt);
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (open && summaryData) {
            setEmail(summaryData?.customerEmail);
            console.log(customerPhoneNumber)
            setPhoneNumber(customerPhoneNumber);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, summaryData, customerPhoneNumber])

    const resetForm = () => {
        onClose();

        setEmail("");
        setPhoneNumber("");
    }

    const handleDisableVehicleLocation = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isCompletedOrCancelled) {
            setConfirmData({
                title: 'Confirm for Share Location Request',
                summary: `Are you sure you want to sent Share Location Request?`,
                confirmBtn: 'Yes',
                isConfirm: async (callback: any) => {
                    callback();

                    setPleaseWait(true);

                    await post_DisabledVehicleLocation({
                        reservationId: reservationId,
                        vehicleId: summaryData?.vehicleId,
                        email: email,
                        phoneNumber: phoneNumber,
                        status: "Sent",
                        link: "",
                        uniqid: "",
                        latitude: 0,
                        longitude: 0,
                        location: "",
                        comment: "",
                        isResponded: false,
                        createdBy: auth.givenname,
                        createdAt: new Date(UpdateTimezone).toLocaleString()
                    }, auth?.id, tenantId)
                        .then(() => {
                            refreshTheShareLocationRequest();
                            resetForm();
                            setPleaseWait(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWait(false);
                            handleTenantError(error);
                        })
                }
            });

            setConfirmPopup(true);
        }
    };

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullScreen={false}
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: '600px',
                    width: '100%',
                    borderRadius: '16px',
                },
            }}
        >
            <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320.591 320.591"
                    className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                    onClick={() => onClose()}
                >
                    <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                    <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                </svg>
                <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full`}>
                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Share Location Request</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2">
                                <div className="w-full">
                                    <form onSubmit={handleDisableVehicleLocation}>
                                        <div className="grid grid-cols-1 gap-x-2 gap-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email</label>
                                                <EmailValidatedComponent
                                                    text={email}
                                                    setText={setEmail}
                                                    required={true}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                                                <PhoneNumberInput
                                                    name={"phoneNumber"}
                                                    value={phoneNumber}
                                                    setValue={setPhoneNumber}
                                                    fontSize={"14px"}
                                                    paddingBlock={"5px"}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex gap-4 mt-[3rem]">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={onClose}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit"
                                            >
                                                Send Request
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ShareLocationRequest